module.exports = __webpack_public_path__ + "img/replace_all.5fc13c31.png";